import { useFilePreview } from '../../File'
import { ICON_HEIGHT_40, IconSpinner } from '../../Icon'

import * as styles from './AudioPreview.module.css'

function AudioPreview({
  className = styles.FilePreviewAudio,
  file: audio,
  getFileById,
  scope,
  subject,
}) {
  const { file, loading } = useFilePreview({
    apiParams: { object_id: subject, scope },
    file: audio,
    getFileById,
  })

  return !file || loading ? (
    <IconSpinner size={ICON_HEIGHT_40} />
  ) : (
    /* eslint-disable-next-line jsx-a11y/media-has-caption -- user-uploaded media has no caption track */
    <audio controls className={className}>
      <source src={file?.origin} type={file.mime_type} />
    </audio>
  )
}

export default AudioPreview
